import { FC, useState } from "react";
import { DateView, DatePicker } from "@mui/x-date-pickers";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form";
import { Typography } from "@mui/material";
import { Calendar } from "react-feather";

type InputFieldProps = {
  label?: string;
  disabled?: boolean;
  required?: boolean;
  gutter?: boolean;
  views?: DateView[];
  field: ControllerRenderProps;
  fieldState: ControllerFieldState;
};

const DatePickerField: FC<InputFieldProps> = ({
  label,
  field,
  disabled,
  views,
  required
}) => {
  const [pickerOpen, setPickerOpen] = useState(false);

  return (
    <>
      <Typography sx={{ fontWeight: "bold", fontSize: "0.8rem" }}>
        {label || "\u00A0"}
      </Typography>
      <DatePicker
        open={pickerOpen}
        onClose={() => setPickerOpen(false)}
        onOpen={() => setPickerOpen(true)}
        disabled={disabled}
        value={field.value}
        onChange={field.onChange}
        views={views}
        slotProps={{
          textField: {
            InputProps: {
              startAdornment: <Calendar />,
              endAdornment: null
            },
            onClick: () => setPickerOpen(true),
            disabled,
            required,
            sx: {
              padding: "8px",
              "& .MuiOutlinedInput-root": {
                padding: "0"
              }
            }
          }
        }}
        sx={{
          marginTop: "10px",
          padding: "0"
        }}
        componentsProps={{
          actionBar: {
            actions: ["clear", "accept"]
          }
        }}
      />
    </>
  );
};

export default DatePickerField;
